module.exports = __webpack_public_path__ + "img/w3_sort_dark.9b6bb5fc.png";